import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=5f8ad4ca&"
import script from "./ProductEditor.vue?vue&type=script&lang=js&"
export * from "./ProductEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports